export const steps = {
	COOKIE_CODE: "citrus_order_step",
	ADDRESS: "DELIVERY_ADDRESS",
	TIME: "DELIVERY_TIME",
}

export let stepsMixin = {
	data() {
		return {
			blocks: [
				{
					name: steps.ADDRESS,
					selected: true,
					completed: false,
					active: true,
					goal: ""
				},
				{
					name: steps.TIME,
					selected: false,
					completed: false,
					active: true,
					goal: ""
				},
			],
		}
	},
	methods: {
		__initStep() {
			let activeStep = this.getSavedActiveStep();
			if (activeStep) {
				this.setActiveStep(activeStep);
			}
		},
		setActiveStep(stepName) {
			for (let block of this.blocks) {
				if (block.name === stepName) {
					block.selected = true;
					break;
				}

				block.selected = false;
				block.completed = true;
			}
		},
		prevTab(block, index) {
			block.selected = false;
			block.completed = true;

			--index;
			this.blocks[index]['selected'] = true;
			this.saveActiveStep(this.blocks[index].name);

			this.scrollToStartForm();
		},
		/**
		 * Включена ли пощаговая валидация
		 *
		 * @returns {boolean}
		 */
		isNeedValidate() {
			return !this.params.hasOwnProperty('STEP_VALIDATE')
				|| this.params.STEP_VALIDATE === true;
		},
		async nextTab(block, index) {
			if (this.isNeedValidate()) {
				let isValid = await this.isValidateBlock(block.name);
				if (!isValid) {

					let errorFirelds = document.getElementsByClassName('form-field_error');
					let scrollElement = errorFirelds[0].closest('.form__groups--item');

					this.scrollToBlock(scrollElement);
					return;
				}
			}

			block.selected = false;
			block.completed = true;

			++index;
			this.blocks[index]['selected'] = true;

			let goal = "unknown";
			switch (this.blocks[index].name)
			{
				case steps.ADDRESS:
						goal = this.metricGoal.EDIT_CONTACT;
					break;
				case steps.TIME:
						goal = this.metricGoal.EDIT_DELIVERY;
					break;
			}

			this.$gtag.event(goal);
			this.$metrika.reachGoal(goal);

			this.saveActiveStep(this.blocks[index].name);
			this.scrollToStartForm();
		},
		scrollToStartForm() {
			const form = document.getElementById(this.templateId);
			form.scrollIntoView({block: "start", inline: "center", behavior: "smooth"});
		},
		async isValidateBlock(blockName) {

			let val = null, isValid = true,
				ref = 'fields';

			if (!this.$refs.hasOwnProperty(ref)) {
				return true;
			}

			for (let field of this.$refs[ref])
			{
				if (!field.$props.hasOwnProperty('fieldProps') || typeof field.$props.fieldProps.CODE != "string") {
					continue;
				}

				if (!this.propertyInBlock(field.$props.fieldProps.CODE, blockName)) {
					continue;
				}

				val = await field.checkValid();
				if (!val) {
					isValid = false;
				}
			}

			return isValid;
		},
		propertyInBlock(propertyCode, blockName) {
			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				if (gProperty.code != blockName) {
					continue;
				}

				for (let itemProperty of gProperty.items) {
					if (propertyCode == itemProperty.CODE) {
						return true;
					}
				}
			}

			return false;
		},
		editBlock(element) {
			if (!element.completed) return;
			for (let block of this.blocks) {
				if (block.selected) block.completed = true;
				block.selected = false;
			}
			element.selected = true;
			this.saveActiveStep(element.name);
		},
		saveActiveStep(stepName) {
			BX.setCookie(steps.COOKIE_CODE, stepName, {path: BX.message('SITE_DIR')});
		},
		getSavedActiveStep() {
			return BX.getCookie(steps.COOKIE_CODE);
		},
		clearSavedActiveStep() {
			BX.setCookie(steps.COOKIE_CODE, "", {path: BX.message("SITE_DIR"), expires: -1});
		},
		scrollToBlock(el) {
			el.scrollIntoView({block: "start", behavior: "smooth"});
		},
	}
}

export default stepsMixin;
